import React, { Component } from 'react'
import { PropTypes } from 'prop-types'
import { get } from 'lodash'
import { Modal } from 'containers/misc'
import { Button } from 'components/misc'
import { form, permissions } from 'helpers/decorators'
import { Select } from 'components/fields'
import { compose } from 'recompose'
import { apiOrganizations } from 'helpers/decorators/api'
import { connect } from 'react-redux'
import { gopsDropdownSelector, sgopsDropdownSelector } from 'redux/selectors/organizations'
import { modal } from 'redux/modules/app'
import { validateAssignGOP } from 'models/organization'

const enhance = compose(
  apiOrganizations({
    codeList: true,
    filter: 'awardUnitsOrIacs',
    minimal: true,
    disableLimit: true
  }),
  permissions(),
  connect(
    state => ({
      dropdownGOPs: gopsDropdownSelector(state),
      dropdownSGOPs: sgopsDropdownSelector(state)
    }),
    {
      modal
    }
  ),
  form({
    form: 'gop-assignment-form',
    validate: validateAssignGOP
  })
)

class GOPAssignmentModal extends Component {
  static propTypes = {
    modalId: PropTypes.string.isRequired,
    modal: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    values: PropTypes.object.isRequired,
    submitting: PropTypes.bool,
    organizations: PropTypes.object,
    dropdownGOPs: PropTypes.array.isRequired,
    dropdownSGOPs: PropTypes.array.isRequired,
    setGlobalOperatingPartnerToOrgRegistration: PropTypes.func.isRequired,
    awardUnitRegistrationId: PropTypes.number.isRequired,
    orgId: PropTypes.number.isRequired,
    getGlobalOperatingPartnerList: PropTypes.func.isRequired,
    getSubGlobalOperatingPartnerList: PropTypes.func.isRequired,
    permissions: PropTypes.object.isRequired
  }

  static defaultProps = {
    values: {}
  }

  componentWillReceiveProps(nextProps) {
    const { orgId, permissions: appPermissions } = this.props

    if (orgId !== nextProps.orgId) {
      (appPermissions.isIf || appPermissions.isGbt) && this.props.getGlobalOperatingPartnerList()
    }
  }

  handleSelectGOP = async(item) => {
    const gopId = get(item, 'value')

    await gopId && this.props.getSubGlobalOperatingPartnerList(gopId)
  }

  handleAssignGOP = fields => {
    const { awardUnitRegistrationId } = this.props

    this.props.setGlobalOperatingPartnerToOrgRegistration(awardUnitRegistrationId, get(fields, 'gopId'), get(fields, 'sgopId'))
  }

  render() {
    const {
      modalId,
      values,
      submitting,
      dropdownGOPs,
      dropdownSGOPs,
      organizations,
      handleSubmit
    } = this.props


    const disableSubmit = (!get(values, 'gopId') && !(dropdownSGOPs && dropdownSGOPs.length > 0)) ||
        (!get(values, 'sgopId') && dropdownSGOPs && dropdownSGOPs.length > 0)

    return (

      <Modal id={modalId} modal={modal} customActions enableOverflow>
        <form onSubmit={handleSubmit(this.handleAssignGOP)}>
          <div className="row">
            <div className="col-xs-12">
              <Select
                label="Global Operating Partners"
                name="gopId"
                intlKey="label.gops"
                options={dropdownGOPs}
                loading={organizations.loading}
                onSelectChange={item => this.handleSelectGOP(item)}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-xs-12">
              <Select
                  label="Sub-Global Operating Partners"
                  name="sgopId"
                  intlKey="label.sgops"
                  options={dropdownSGOPs}
                  loading={organizations.loading}
                  disabled={!(dropdownSGOPs && dropdownSGOPs.length > 0) || !get(values, 'gopId')}
              />
            </div>
          </div>

          <div className="row">
            <div className="col-xs-6">
              <Button
                secondary
                type="button"
                intlKey="button.close"
                onClick={() => this.props.modal(null)}
              >
                Close
              </Button>
            </div>
            <div className="col-xs-6 text--right">
              <Button
                intlKey="button.assign"
                isLoading={submitting}
                disabled={disableSubmit}
                onClick={() => this.props.modal(null)}
              >
                Assign
              </Button>
            </div>
          </div>
        </form>
      </Modal>
    )
  }
}

export default enhance(GOPAssignmentModal)
